module.exports = __webpack_public_path__ + "static/media/happy-Anniversary-news.2df1bf24.jpg";